exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.accommodation-container[data-v-4ff39b92]{display:grid\n}\n@media (min-width:900px){\n.accommodation-container[data-v-4ff39b92]{grid-gap:40px;grid-template-columns:2fr 1fr\n}\n}\n.accommodation-container .accommodation-gallery[data-v-4ff39b92]{border:1px solid #d5dde2;margin-top:29px;padding:20px\n}\nhr[data-v-4ff39b92]{margin:60px 0\n}", ""]);

// exports
